export default "__VITE_ASSET__CQr_BvgS__"